export default class ResetToTimestampRequest{
  public constructor(
    public dataItemId: string,
    public timestamp: number
  ){}
}
